export default "__VITE_ASSET__BeXiiJhL__"